import React from 'react'

export default function LinkExpired() {
  return (
    <div>
        <div>
            <h1>Link Expired</h1>
            <button>Return to website</button>
        </div>
        <div>
            <img src="./error_dog.png"/>
        </div>
    </div>
  )
}
